import { fetchFromAPI } from 'utils/api';

export const getReportTemplates = (params) => fetchFromAPI('/svr_templates', { params });
export const getFarmReportTemplates = (farmId, params) => fetchFromAPI(`/farms/${farmId}/svr_templates`, { params });
export const getReportTemplate = (id) => fetchFromAPI(`/svr_templates/${id}`).then(({ resource }) => resource);
